import React from 'react';
import { useForm } from 'react-hook-form';
import { Row, Col } from 'react-bootstrap';
import '../s_csvc-css/beta.css'; 

const Beta = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onReactHookFormSubmit = (data) => {
    console.log(data);
  };

  const year = "2024";
  const previousText = "Lorem ipsum";
  const previousValue = 1000;

  return (
    <form onSubmit={handleSubmit(onReactHookFormSubmit)}>
      <Row className="g-0">
          <Col xs={6} md={2} className='border-200 border-bottom border-end d-flex align-items-center justify-content-end'>
          <p className="font-sans-serif lh-1 mb-1 fs-7 text-end ">{year}</p>
          </Col>

          <Col xs={6} md={8} className='border-200 border-md-200 border-bottom border-md-end pb-3 pt-3 ps-3'>
              <textarea 
                  id="perPrecGiust" 
                  {...register('perPrecGiust')} 
                  autoComplete="off" 
                  defaultValue={previousText} 
                  style={{ height: '150px', width: '100%' }} 
              ></textarea><br />
              {errors.perPrecGiust && <p>Il valore del periodo corrente è obbligatorio</p>}
          </Col>


          <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
              <input 
                  type="number" 
                  id="perPrecValore" 
                  {...register('perPrecValore')} 
                  autoComplete="off" 
                  defaultValue={previousValue} 
                  className="no-arrows" 
                  style={{ width: '100%' }} 
              /><br />
              {errors.perPrecGiust && <p>Il valore del periodo corrente è obbligatorio</p>}
            </Col>
      </Row>
      <Row>
        <button type="submit">Invia</button>
      </Row>
    </form>
  );
};

export default Beta;

/*
import React from 'react';
import { useForm } from 'react-hook-form'

import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Beta = () => {
  const {register, handleSubmit, formState: {errors}} = useForm()

  const onReactHookFormSubmit = (data) => {
      console.log(data)
  }

  const previousText = "Lorem ipsum"
  const previousValue = 1000


  return (<>
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">Beta</div>
        <p>https://www.youtube.com/watch?v=wtlD7pWgu3c</p>


        <hr />
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Vai alla Homepage
        </Link>
      </Card.Body>
    </Card>

    <form onSubmit={handleSubmit(onReactHookFormSubmit)}>
      <textarea id="one" {...register('one', {required: true} )} autoComplete="off" >{previousText}</textarea><br />
      {errors.one && <p>one è obbligatorio</p>}<br />

      <input type="two"  id="two" {...register('two', {required: true} )} autoComplete="off" defaultValue={previousValue} /><br />
      {errors.two && <p>two è obbligatrio</p>}<br />

      <button type="submit">Invia</button>
    </form>



  </>);
};

export default Beta;

///////////////////////////////

      <Row className="g-0">
        <Col xs={6} md={2} className='border-200 border-bottom border-end d-flex align-items-center justify-content-end'>
          <p className="font-sans-serif lh-1 mb-1 fs-7">{year}</p>
        </Col>
        <Col xs={6} md={8} className='border-200 border-md-200 border-bottom border-md-end pb-3 pt-3 ps-3'>
          <textarea 
            id="one" 
            {...register('one', { required: true })} 
            autoComplete="off" 
            defaultValue={previousText} 
            style={{ height: '150px', width: '100%' }} 
          ></textarea><br />
          {errors.one && <p>one è obbligatorio</p>}<br />
        </Col>
        <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 d-flex align-items-center pb-3 pt-3 ps-3'>
          <input 
            type="number" 
            id="two" 
            {...register('two', { required: true })} 
            autoComplete="off" 
            defaultValue={previousValue} 
            className="no-arrows" 
            style={{ width: '100%' }} 
          /><br />
          {errors.two && <p>two è obbligatorio</p>}<br />
        </Col>
      </Row>
      <Row>
        <button type="submit">Invia</button>
      </Row>


*/